import { Guid } from 'guid-typescript';

export class FundTransferModel {
  id: Guid;
  transferDate: Date | any;
  amount?: number;
  fromFundId: Guid;
  toFundId: Guid;
  note: string;
  fromBankId?:Guid;
  toBankId?:Guid;
}
